import { render, staticRenderFns } from "./SampleList.vue?vue&type=template&id=c1a532ee&scoped=true"
import script from "./SampleList.vue?vue&type=script&lang=ts"
export * from "./SampleList.vue?vue&type=script&lang=ts"
import style0 from "./SampleList.vue?vue&type=style&index=0&id=c1a532ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a532ee",
  null
  
)

export default component.exports